<p-toast></p-toast>

<form [formGroup]="inviteUserForm" (ngSubmit)="onSubmit()">
  <div class="modal-form-body invite-user-form-body">
    <div class="grid">

      <div class="col-12">
        <label for="email" class="modal-label">Email Address <span class="req">*</span></label>
        <input id="email" type="email" pInputText formControlName="email" placeholder="Enter email address"
          class="w-full" [class.p-invalid]="f['email'].invalid && f['email'].touched" [autofocus]="!isEditMode" />
        <small class="modal-error" *ngIf="f['email'].invalid && f['email'].touched">
          <span *ngIf="f['email'].errors?.['required']">Email is required</span>
          <span *ngIf="f['email'].errors?.['email']">Please enter a valid email address</span>
        </small>
      </div>

      <div class="col-12 md:col-6">
        <label for="firstName" class="modal-label">First Name <span class="req">*</span></label>
        <input id="firstName" type="text" pInputText formControlName="firstName" placeholder="Enter first name"
          class="w-full" [class.p-invalid]="f['firstName'].invalid && f['firstName'].touched" [autofocus]="isEditMode" />
        <small class="modal-error" *ngIf="f['firstName'].invalid && f['firstName'].touched">
          <span *ngIf="f['firstName'].errors?.['required']">First name is required</span>
          <span *ngIf="f['firstName'].errors?.['minlength']">First name must be at least 3 characters</span>
          <span *ngIf="f['firstName'].errors?.['maxlength']">First name cannot exceed 50 characters</span>
        </small>
      </div>

      <div class="col-12 md:col-6">
        <label for="lastName" class="modal-label">Last Name <span class="req">*</span></label>
        <input id="lastName" type="text" pInputText formControlName="lastName" placeholder="Enter last name"
          class="w-full" [class.p-invalid]="f['lastName'].invalid && f['lastName'].touched" />
        <small class="modal-error" *ngIf="f['lastName'].invalid && f['lastName'].touched">
          <span *ngIf="f['lastName'].errors?.['required']">Last name is required</span>
          <span *ngIf="f['lastName'].errors?.['minlength']">Last name must be at least 3 characters</span>
          <span *ngIf="f['lastName'].errors?.['maxlength']">Last name cannot exceed 50 characters</span>
        </small>
      </div>

      <div class="col-12 md:col-6">
        <label for="role" class="modal-label">Role <span class="req">*</span></label>
        <p-select id="role" formControlName="role" [options]="roleOptions" placeholder="Select a role"
          optionLabel="roleName" optionValue="roleId" class="w-full" [loading]="loadingOptions"
          appendTo="body" scrollHeight="200px" [virtualScroll]="false" [filter]="false"
          [class.p-invalid]="f['role'].invalid && f['role'].touched" />
        <small class="modal-error" *ngIf="f['role'].invalid && f['role'].touched">Role is required</small>
      </div>

	      <div class="col-12 md:col-6">
	        <label for="userType" class="modal-label">User Type <span class="req">*</span></label>
	        <p-select id="userType" formControlName="userType" [options]="filteredUserTypeOptions"
	          [placeholder]="f['role'].value ? 'Select user type' : 'Select role first'" optionLabel="name" optionValue="userTypeId" class="w-full"
	          [loading]="loadingOptions" appendTo="body" scrollHeight="200px" [virtualScroll]="false"
	          [filter]="false" [disabled]="!f['role'].value || loadingOptions"
	          [class.p-invalid]="f['userType'].invalid && f['userType'].touched" />
	        <small class="modal-error" *ngIf="f['userType'].invalid && f['userType'].touched">User type is required</small>
	      </div>

      <div class="col-12 md:col-6">
        <label for="address1" class="modal-label">Address 1</label>
        <input id="address1" type="text" pInputText formControlName="address1" placeholder="Enter address line 1"
          class="w-full" [class.p-invalid]="f['address1'].invalid && f['address1'].touched" />
        <small class="modal-error" *ngIf="f['address1'].invalid && f['address1'].touched">
          <span *ngIf="f['address1'].errors?.['maxlength']">Address 1 cannot exceed 200 characters</span>
        </small>
      </div>

      <div class="col-12 md:col-6">
        <label for="address2" class="modal-label">Address 2</label>
        <input id="address2" type="text" pInputText formControlName="address2" placeholder="Enter address line 2"
          class="w-full" [class.p-invalid]="f['address2'].invalid && f['address2'].touched" />
        <small class="modal-error" *ngIf="f['address2'].invalid && f['address2'].touched">
          <span *ngIf="f['address2'].errors?.['maxlength']">Address 2 cannot exceed 200 characters</span>
        </small>
      </div>

      <div class="col-12 md:col-6">
        <label for="city" class="modal-label">City <span class="req">*</span></label>
        <input id="city" type="text" pInputText formControlName="city" placeholder="Enter city"
          class="w-full" [class.p-invalid]="f['city'].invalid && f['city'].touched" />
        <small class="modal-error" *ngIf="f['city'].invalid && f['city'].touched">
          <span *ngIf="f['city'].errors?.['required']">City is required</span>
          <span *ngIf="f['city'].errors?.['maxlength']">City cannot exceed 100 characters</span>
        </small>
      </div>

      <div class="col-12 md:col-6">
        <label for="state" class="modal-label">State <span class="req">*</span></label>
        <input id="state" type="text" pInputText formControlName="state" placeholder="Enter state"
          class="w-full" [class.p-invalid]="f['state'].invalid && f['state'].touched" />
        <small class="modal-error" *ngIf="f['state'].invalid && f['state'].touched">
          <span *ngIf="f['state'].errors?.['required']">State is required</span>
          <span *ngIf="f['state'].errors?.['maxlength']">State cannot exceed 100 characters</span>
        </small>
      </div>

      <div class="col-12 md:col-6">
        <div class="grid">
          <div class="col-12 md:col-6">
            <label for="zip" class="modal-label">Zip Code</label>
            <input id="zip" type="text" pInputText formControlName="zip" placeholder="Enter zip code"
              class="w-full" [class.p-invalid]="f['zip'].invalid && f['zip'].touched" />
            <small class="modal-error" *ngIf="f['zip'].invalid && f['zip'].touched">
              <span *ngIf="f['zip'].errors?.['maxlength']">Zip code cannot exceed 20 characters</span>
            </small>
          </div>

          <div class="col-12 md:col-6">
            <label for="country" class="modal-label">Country</label>
            <input id="country" type="text" pInputText formControlName="country" placeholder="Enter country"
              class="w-full" [class.p-invalid]="f['country'].invalid && f['country'].touched" />
            <small class="modal-error" *ngIf="f['country'].invalid && f['country'].touched">
              <span *ngIf="f['country'].errors?.['maxlength']">Country cannot exceed 100 characters</span>
            </small>
          </div>
        </div>
      </div>

      <div class="col-12 md:col-6">
        <label for="phoneNumber" class="modal-label">Phone Number <span class="req">*</span></label>
        <input id="phoneNumber" type="text" pInputText formControlName="phoneNumber" placeholder="Enter phone number"
          class="w-full" [class.p-invalid]="f['phoneNumber'].invalid && f['phoneNumber'].touched" />
        <small class="modal-error" *ngIf="f['phoneNumber'].invalid && f['phoneNumber'].touched">
          <span *ngIf="f['phoneNumber'].errors?.['required']">Phone number is required</span>
          <span *ngIf="f['phoneNumber'].errors?.['maxlength']">Phone number cannot exceed 20 characters</span>
        </small>
      </div>

    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="modal-btn-cancel" (click)="onCancel()" [disabled]="isSubmitting">Cancel</button>
    <button type="submit" class="modal-btn-primary" [disabled]="inviteUserForm.invalid || isSubmitting">
      {{ isSubmitting ? 'Saving...' : (isEditMode ? 'Save' : 'Send Invitation') }}
    </button>
  </div>

</form>
